// extracted by mini-css-extract-plugin
module.exports = {"component":"Container_component__ASyIq"};